import React from 'react';
import { useTranslation } from 'react-i18next';
import { parseExploreUnknownMissionDepth } from '../utils/exploreUnknownMissionDepth';
import './ExploreUnknownMissionDepthDisplay.css';

/**
 * @param {{
 *   missions: number | null | undefined,
 *   easyCount: number | null | undefined,
 *   className?: string,
 *   showCellHint?: boolean,
 * }} props
 */
function ExploreUnknownMissionDepthDisplay({
  missions,
  easyCount,
  className = '',
  showCellHint = false,
}) {
  const { t } = useTranslation();
  const parsed = parseExploreUnknownMissionDepth(missions, easyCount);

  if (!parsed) {
    return <span className={className}>-</span>;
  }

  const { missionNum, easyNum } = parsed;
  const ariaLabel =
    easyNum > 0
      ? t('exploreUnknownRanking.missionDepthWithEasyAria', { depth: missionNum, easy: easyNum })
      : t('exploreUnknownRanking.missionDepthAria', { depth: missionNum });
  const title =
    showCellHint && easyNum > 0 ? t('exploreUnknownRanking.columnHint') : undefined;

  return (
    <span
      className={`eu-mission-depth-display${className ? ` ${className}` : ''}`}
      aria-label={ariaLabel}
      title={title}
    >
      <span className="eu-mission-depth-value">{missionNum}</span>
      {easyNum > 0 ? (
        <span className="eu-mission-depth-easy">
          <span className="eu-mission-depth-separator" aria-hidden="true">
            ·
          </span>
          <span className="eu-mission-depth-easy-count">{easyNum}</span>
          <img
            src="/images/pacifier.png"
            alt=""
            className="eu-mission-depth-pacifier"
            aria-hidden="true"
          />
          <span className="eu-mission-depth-easy-label">
            {t('exploreUnknownRanking.easyMissionsShort')}
          </span>
        </span>
      ) : null}
    </span>
  );
}

export default ExploreUnknownMissionDepthDisplay;
